<app-ace-select
  [formControl]="formControl"
  [loading]="loading"
  [items]="equipment"
  [bindLabel]="DISPLAY_LABEL_NAME"
  [bindValue]="bindToEquipmentId ? EQUIPMENT_ID_KEY : null"
  [multiSelect]="multiSelect"
  [compareWith]="bindToEquipmentId ? null : compareFn"
  [placeholder]="placeholder != null ? placeholder : ('Equipment' | messageTranslate)"
  [maxSelectedLabels]="maxSelectedLabels"
  [maxSelectedShowItemName]="maxSelectedShowItemName"
  [maxSelectedItemName]="maxSelectedItemName"
  [truncateLabels]="truncateLabels"
  [customItemTooltip]="tooltipById?.size ? getTooltip : null"
  [hideValueLabelsWhileLoading]="hideValueLabelsWhileLoading"
  [hideSelected]="hideSelected"
  [groupBy]="groupBy"
  [searchFn]="searchFn"
  [appendTo]="appendTo"
  [isReadOnly]="isReadOnly"
  [closeOnSelect]="!multiSelect"
  [showItemsWhileLoading]="showItemsWhileLoading"
  [clearable]="clearable"
  (touched)="aceSelectTouched()"
  (openEvent)="onOpen()"
  (closeEvent)="onClose()"/>